import * as Sentry from '@sentry/react';

// ----------------------------------------------------------------------

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE;
const release = import.meta.env.VITE_SENTRY_RELEASE;

if (typeof dsn === 'string' && dsn.length > 0) {
  const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0) || 0;
  const serverUrl = import.meta.env.VITE_SERVER_URL as string | undefined;
  const tracePropagationTargets: (string | RegExp)[] = [/^https?:\/\/localhost(?::\d+)?/];
  if (serverUrl) {
    tracePropagationTargets.unshift(serverUrl);
  }

  Sentry.init({
    dsn,
    environment,
    release,
    sendDefaultPii: false,
    integrations: tracesSampleRate > 0 ? [Sentry.browserTracingIntegration()] : [],
    tracePropagationTargets,
    tracesSampleRate,
  });

  if (import.meta.env.DEV) {
    // Confirms which values Vite embedded (restart dev server after changing .env).
    // eslint-disable-next-line no-console -- intentional startup diagnostic
    console.info('[Sentry]', {
      environment,
      release: release ?? '(not set)',
      tracesSampleRate,
      viteMode: import.meta.env.MODE,
    });
  }
} else if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console -- intentional startup diagnostic
  console.info('[Sentry] disabled: set VITE_SENTRY_DSN to enable');
}
